import { render } from "./AssignAC.vue?vue&type=template&id=094bbbae"
import script from "./AssignAC.vue?vue&type=script&lang=js"
export * from "./AssignAC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__